import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import api from "../../api";

import {
  useNavigate
} from "react-router-dom";

function ProformaForm() {

  const navigate = useNavigate();

  // ===========================
  // ETAT GENERAL
  // ===========================

  const [loading, setLoading] =
    useState(false);

  const [loadingPrestations,
    setLoadingPrestations] =
    useState(true);

  const [prestations,
    setPrestations] =
    useState([]);

  // ===========================
  // FORMULAIRE
  // ===========================

  const [form, setForm] =
    useState({

      contact: "",

      telephone: "",

      email: "",

      langue: "FR",

      devise: "USD",

      validite: 15,

      observations: ""

    });

  // ===========================
  // LIGNES
  // ===========================

  const [lignes,
    setLignes] =
    useState([

      {

        prestation_id: "",

        designation: "",

        quantite: 1,

        prix_unitaire: 0,

        montant: 0

      }

    ]);

  // ===========================
  // CHARGEMENT PRESTATIONS
  // ===========================

  useEffect(() => {

    loadPrestations();

  }, []);

  const loadPrestations =
    async () => {

      try {

        const res =
          await api.get(
            "/prestations"
          );

        setPrestations(
          res.data || []
        );

      } catch (err) {

        console.error(err);

        alert(
          "Impossible de charger les prestations."
        );

      } finally {

        setLoadingPrestations(
          false
        );

      }

    };


  // ===========================
  // CHANGEMENT CHAMPS
  // ===========================

  const handleChange =
    (e) => {

      const {

        name,

        value

      } = e.target;

      setForm({

        ...form,

        [name]: value

      });

    };

  // ===========================
  // AJOUT LIGNE
  // ===========================

  const addLine =
    () => {

      setLignes([

        ...lignes,

        {

          prestation_id: "",

          designation: "",

          quantite: 1,

          prix_unitaire: 0,

          montant: 0

        }

      ]);

    };

  // ===========================
  // SUPPRIMER LIGNE
  // ===========================

  const removeLine =
    (index) => {

      if (
        lignes.length === 1
      ) return;

      setLignes(

        lignes.filter(

          (_, i) => i !== index

        )

      );

    };

  // ===========================
  // TOTAL
  // ===========================

  const total =
    useMemo(() => {

      return lignes.reduce(

        (sum, l) =>

          sum +

          Number(
            l.montant || 0
          ),

        0

      );

    }, [lignes]);


    // ===========================
    // ENREGISTREMENT
    // ===========================

    const handleSubmit = async (e) => {

      e.preventDefault();

      // ===========================
      // VALIDATION INFORMATIONS
      // ===========================

      if (!form.contact?.trim()) {
        return alert("Veuillez renseigner la personne de contact.");
      }

      if (!form.telephone?.trim()) {
        return alert("Veuillez renseigner le numéro de téléphone.");
      }

      if (!form.email?.trim()) {
        return alert("Veuillez renseigner l'adresse e-mail.");
      }

      if (!form.validite || Number(form.validite) <= 0) {
        return alert(
          "Veuillez renseigner une durée de validité valide."
        );
      }

      // ===========================
      // VALIDATION PRESTATIONS
      // ===========================

      if (lignes.length === 0) {
        return alert("Ajoutez au moins une prestation.");
      }

      for (let i = 0; i < lignes.length; i++) {

        const ligne = lignes[i];

        if (!ligne.prestation_id) {
          return alert(
            `Veuillez sélectionner une prestation à la ligne ${i + 1}.`
          );
        }

        if (
          ligne.quantite === "" ||
          ligne.quantite === null ||
          ligne.quantite === undefined ||
          Number(ligne.quantite) <= 0
        ) {
          return alert(
            `Veuillez renseigner une quantité valide à la ligne ${i + 1}.`
          );
        }

        if (
          ligne.prix_unitaire === "" ||
          ligne.prix_unitaire === null ||
          ligne.prix_unitaire === undefined ||
          Number(ligne.prix_unitaire) < 0
        ) {
          return alert(
            `Veuillez renseigner un prix unitaire valide à la ligne ${i + 1}.`
          );
        }
      }

      // ===========================
      // CONFIRMATION
      // ===========================

      if (!window.confirm(
        "Confirmer la création de cette proforma ?"
      )) {
        return;
      }

      setLoading(true);

      try {

        const dateValidite = new Date();

        dateValidite.setDate(
            dateValidite.getDate() + Number(form.validite)
        );

        const payload = {
            ...form,
            date_validite: dateValidite.toISOString().slice(0, 10),
            prestations: lignes
        };

        await api.post("/proformas", payload);

        alert("Proforma créée avec succès.");

        navigate("/proformas");

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.message ||
          "Erreur lors de l'enregistrement."
        );

      } finally {

        setLoading(false);

      }

    };


    // ===========================
  // RENDER
  // ===========================

  return (

    <div className="min-h-[100dvh] bg-gray-100 flex justify-center items-start p-3 md:p-6">

      <div className="w-full max-w-6xl bg-white rounded-2xl shadow-lg p-4 md:p-8">

        {/* HEADER */}

        <div className="mb-6">

          <h2 className="text-2xl md:text-3xl font-bold">

            Nouvelle proforma

          </h2>

          <p className="text-sm text-gray-500 mt-1">

            Préparez une offre commerciale pour votre client.

          </p>

        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-6"
        >

          {/* ===========================
              INFORMATIONS GENERALES
          =========================== */}

          <div>

            <h3 className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">

              Informations générales

            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <input
                name="contact"
                value={form.contact}
                onChange={handleChange}
                placeholder="Nom du demandeur *"
                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
              />

              <input

                name="telephone"

                value={form.telephone}

                onChange={handleChange}

                placeholder="+243..."

                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"

              />

              <input

                type="email"

                name="email"

                value={form.email}

                onChange={handleChange}

                placeholder="Email"

                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"

              />

              <select

                name="langue"

                value={form.langue}

                onChange={handleChange}

                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"

              >

                <option value="FR">

                  Français

                </option>

                <option value="EN">

                  English

                </option>

              </select>

              <select

                name="devise"

                value={form.devise}

                onChange={handleChange}

                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"

              >

                <option value="USD">

                  USD

                </option>

                <option value="CDF">

                  CDF

                </option>

              </select>

              <input

                type="number"

                name="validite"

                min="1"

                value={form.validite}

                onChange={handleChange}

                placeholder="Validité"

                className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"

              />

            </div>

          </div>

          {/* ===========================
              PRESTATIONS
          =========================== */}

          <div>

            <div className="flex justify-between items-center mb-3">

              <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">

                Prestations

              </h3>

              <button

                type="button"

                onClick={addLine}

                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-xl"

              >

                ➕ Ajouter

              </button>

            </div>

                        {loadingPrestations ? (

              <div className="bg-gray-50 rounded-xl p-4 text-center">

                Chargement des prestations...

              </div>

            ) : (

              <div className="overflow-x-auto">

                <table className="min-w-full border rounded-xl">

                  <thead className="bg-gray-100">

                    <tr>

                      <th className="px-3 py-3 text-left">
                        Prestation
                      </th>

                      <th className="px-3 py-3 text-center">
                        Qté
                      </th>

                      <th className="px-3 py-3 text-right">
                        Prix unitaire
                      </th>

                      <th className="px-3 py-3 text-right">
                        Total
                      </th>

                      <th className="px-3 py-3 text-center">
                        Action
                      </th>

                    </tr>

                  </thead>

                  <tbody>

                    {lignes.map((ligne, index) => (

                      <tr
                        key={index}
                        className="border-t"
                      >

                        <td className="p-2">

                          <select

                            className="w-full border rounded-lg px-3 py-2"

                            value={ligne.prestation_id}

                            onChange={(e) => {

                              const valeur = e.target.value;

                              const copie = [...lignes];

                              if (!valeur) {

                                copie[index] = {
                                  ...copie[index],
                                  prestation_id: "",
                                  designation: "",
                                  prix_unitaire: 0,
                                  montant: 0
                                };

                                setLignes(copie);

                                return;
                              }

                              const prestation =
                                prestations.find(
                                  p =>
                                    Number(p.id) ===
                                    Number(valeur)
                                );

                              if (!prestation) {
                                return;
                              }

                              copie[index] = {

                                ...copie[index],

                                prestation_id:
                                  prestation.id,

                                designation:
                                  form.langue === "EN"
                                    ? prestation.nom_en
                                    : prestation.nom_fr,

                                prix_unitaire:
                                  Number(
                                    prestation.prix_defaut
                                  ),

                                montant:
                                  Number(
                                    prestation.prix_defaut
                                  ) *
                                  Number(
                                    copie[index].quantite || 0
                                  )

                              };

                              setLignes(copie);

                            }}

                          >

                            <option value="">

                              Sélectionner...

                            </option>

                            {prestations.map(

                              (p) => (

                                <option

                                  key={p.id}

                                  value={p.id}

                                >

                                  {form.langue === "EN" ? p.nom_en : p.nom_fr}

                                </option>

                              )

                            )}

                          </select>

                        </td>

                        <td className="p-2">

                          <input

                            type="number"

                            min="1"

                            className="w-24 border rounded-lg px-3 py-2 text-center"

                            value={

                              ligne.quantite

                            }

                            onChange={(e)=>{

                              const copie=[

                                ...lignes

                              ];

                              copie[index]

                                .quantite=

                                Number(

                                  e.target

                                    .value

                                );

                              copie[index]

                                .montant=

                                copie[index]

                                  .quantite *

                                copie[index]

                                  .prix_unitaire;

                              setLignes(

                                copie

                              );

                            }}

                          />

                        </td>

                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">

                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              value={ligne.prix_unitaire}
                              onChange={(e) => {

                                const nouvellesLignes = [...lignes];

                                nouvellesLignes[index] = {
                                  ...nouvellesLignes[index],
                                  prix_unitaire: e.target.value
                                };

                                setLignes(nouvellesLignes);

                              }}
                              className="border rounded-lg px-3 py-2 w-28 text-right"
                            />

                            <span className="text-gray-600">
                              {form.devise}
                            </span>

                          </div>
                        </td>

                        <td className="p-2 text-right font-semibold">

                          {Number(

                            ligne.montant

                          ).toLocaleString(

                            "fr-FR",

                            {

                              minimumFractionDigits:2

                            }

                          )} {form.devise}

                        </td>

                        <td className="p-2 text-center">

                          <button

                            type="button"

                            onClick={()=>

                              removeLine(

                                index

                              )

                            }

                            className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg"

                          >

                            ✖

                          </button>

                        </td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

            )}

          </div>

          {/* ===========================
            OBSERVATIONS
          =========================== */}

          <div>

            <h3 className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">

              Observations

            </h3>

            <textarea

              name="observations"

              rows="4"

              value={form.observations}

              onChange={handleChange}

              placeholder="Observations particulières..."

              className="w-full border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"

            />

          </div>

          {/* ===========================
              TOTAL
          =========================== */}

          <div className="bg-gray-50 rounded-xl p-5">

            <div className="flex justify-between items-center">

              <span className="text-lg font-semibold">

                Total de la proforma

              </span>

              <span className="text-2xl font-bold text-blue-700">

                {total.toLocaleString(
                  "fr-FR",
                  {
                    minimumFractionDigits: 2
                  }
                )} {form.devise}

              </span>

            </div>

          </div>

          {/* ===========================
              ACTIONS
          =========================== */}

          <div className="flex flex-col md:flex-row gap-3">

            <button

              type="button"

              onClick={() =>
                navigate("/proformas")
              }

              className="flex-1 bg-gray-200 hover:bg-gray-300 py-3 rounded-xl font-semibold"

            >

              Annuler

            </button>

            <button

              type="submit"

              disabled={loading}

              className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-semibold disabled:opacity-50"

            >

              {

                loading

                  ? "Enregistrement..."

                  : "Enregistrer"

              }

            </button>

          </div>

        </form>

      </div>

    </div>

  );

}

export default ProformaForm;